import React from 'react';

// Components
import Slider from '../../components/Slider/Slider';
import WeatherWidget from '../../components/WeatherWidget/WeatherWidget';
import Wave from '../../components/Wave/Wave';

// Icons
import iconBedienung from '../../assets/images/icons/icon-bedienung.svg';
import iconEssen from '../../assets/images/icons/icon-essen.svg';
import iconExtras from '../../assets/images/icons/icon-extras.svg';
import iconKontakt from '../../assets/images/icons/icon-kontakt.svg';
import iconPalme from '../../assets/images/icons/icon-palme.svg';
import iconRundgang from '../../assets/images/icons/icon-rundgang.svg';
import iconWerbefilm from '../../assets/images/icons/icon-werbefilm.svg';

import {
  PageWrapper,
  NavContainer,
  NavItem,
  IconContainer,
  Icon,
  LabelContainer,
  Label,
} from './Home.styles';

const icons = {
  ausflugstipps: iconPalme,
  restauranttipps: iconEssen,
  'extras-und-verleih': iconExtras,
  'bedienung-und-anleitungen': iconBedienung,
  'rundgang-hausboote': iconRundgang,
  'werbefilm-hausboote': iconWerbefilm,
  'hilfe-und-kontakt': iconKontakt,
};

const Home = ({ data }) => {
  return (
    <PageWrapper background>
      {data.sections.header && <Slider data={data.sections.header} />}

      <Wave />

      <NavContainer>
        {data.sections.main.map((page) => (
          <NavItem key={page.id} to={`/${page.alias}`}>
            {page.cssID[1] !== 'weather' ? (
              <>
                <IconContainer>
                  <Icon src={icons[page.alias]} className={page.alias} />
                </IconContainer>

                <LabelContainer>
                  <Label>{page.title}</Label>
                </LabelContainer>
              </>
            ) : (
              <WeatherWidget data={page.content} />
            )}
          </NavItem>
        ))}
      </NavContainer>
    </PageWrapper>
  );
};

export default Home;
